import { CallablePageRef } from 'providers/page-ref';

export type InputCalendarPageParams = {
  dateISO: string;
  title?: string;
  minDateISO?: string;
  maxDateISO?: string;
};

export type InputCalendarPageResult = {
  dateISO: string | null;
};

export const IInputCalendarPage: CallablePageRef<InputCalendarPageParams, InputCalendarPageResult> = {
  pageName: 'InputCalendarPage',
} as CallablePageRef<InputCalendarPageParams, InputCalendarPageResult>;
